const isPosItemsCategory = (category) => category?.get?.('is_pos_items') === true

export function all (state) {
  return state.all
}

export function loading (state) {
  return state.loading
}

export function current (state) {
  return state.current
}

export const byId = (state) => (categoryId) => {
  for (const i in state.all) {
    if (state.all[i].id === categoryId) {
      return state.all[i]
    }
  }
  return false
}

export const byTitle = (state) => (categoryTitle) => {
  for (const i in state.all) {
    if (state.all[i].get('title') === categoryTitle) {
      return state.all[i]
    }
  }
  return false
}

export const getCountedItems = (state) => (categorId) => {
  return state.countedItems[categorId]
}

export const comboCategories = (state) => {
  const result = []

  if (state.all) {
    state.all.forEach(category => {
      const isHidden = category.get('hide')
      const isCombo = category.get('is_combo')
      const isPosItems = isPosItemsCategory(category)

      if(!isHidden && !isPosItems && isCombo) {
        result.push(category)
      }
    })
  }
  return result
}

export const filteredCategories = (state, _, rootState) => {
  const result = []

  if (state.all) {
    state.all.forEach(category => {
      const isHidden = category.get('hide')
      const hasItems = state.countedItems[category.id] > 0
      const isCombo = category.get('is_combo')
      const isPosItems = isPosItemsCategory(category)

      // include combos that don't have items
      if (!isHidden && !isPosItems && (hasItems || isCombo)) {
        result.push(category)
      }
    });
  }
  const business =  rootState.business.business

  if(business && business.get('show_uncategorized')) {
    result.push(new Proxy({
        title: 'Uncategorized',
        id: 'uncategorized',
        color: '#EAEAEA'
      }, {
        get(target, prop) {
          if (prop === 'get') {
            return (key) => target[key];
          }
          if (prop === 'attributes') {
            return target;
          }
          return target[prop];
        }
      }))
  }

  return result
}
